import axios from "axios";
import authHeader from "./auth-header";
import {API_URL} from "./api-uri";

const getBankAccounts = () => {
  return axios
  .get(API_URL + "BankAccounts", { headers: authHeader() })
  .then((response) => {
    return response.data;
  });
};

const upsertBankAccount = (bankaccount) => {
  return axios
  .put(API_URL + "BankAccounts/UpsertBankAccount/" + bankaccount.id, bankaccount)
  .then((response) => {
    return response.data;
  });
};

const deleteBankAccount = (bankaccount_id) => {
  return axios.delete(API_URL + "BankAccounts/" + bankaccount_id).then(() => { return });
};

export default { getBankAccounts,  upsertBankAccount, deleteBankAccount };